<script>
  import Icon from '@leaflink/stash/Icon.vue';
  import camelCase from 'lodash-es/camelCase';

  import { STATUSES } from '@/constants';
  import generateColorClass from '@/utils/generateColorClass';

  export default {
    /**
     * TODO: Potentially replace with, or fold into BrandBadges.vue?
     * Will depend on any badge requirements still to come (Brand Menu, or other)
     */
    name: 'SellerStatusBadge',

    components: {
      Icon,
    },

    props: {
      /**
       * The Seller Status to display a badge for
       */
      status: {
        type: String,
        required: true,
      },
    },

    data() {
      return {
        name: `badge-seller-${STATUSES.SELLER_STATUSES[camelCase(this.status)].id}`,
        color: generateColorClass('certified-seller', this.status),
      };
    },
  };
</script>

<template>
  <Icon :name="name" :class="`tw-text-${color}`" data-test="badge|certified-seller" />
</template>
